var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit-vocs-ratio-chart-group"},_vm._l((_vm.dataGroup),function(data){return (data.dimensions.length === 2)?_c('ratio-chart',{key:data.id,staticStyle:{"flex":"1 0 100%","padding":"10px 0"},attrs:{"data-config":data,"ratio-low":data.ratioLow,"unit-prop":_vm.unitProp}}):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41457451","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/02Data-Audit/01Manual/AuditDeviceViews/VocsRatioChart.vue
// module id = null
// module chunks = 